// extracted by mini-css-extract-plugin
module.exports = {"btnTextStyle":"MyWallsSettings_btnTextStyle_1qni_","headingText":"MyWallsSettings_headingText_ou8Tx"};